import styles from './transport-state.module.css';
import HailIcon from '@mui/icons-material/EmojiPeople';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import { FC } from 'react';
import { Icon } from '@iconify/react';

export interface TransportStateProps {
  state?: 'start' | 'stopped' | 'running';
}

const LIGHT_GRAY = '#d7d8d8';
const WARNING = '#f9c80e';

const StartIcon = () => (
  <div className={styles['stopped-container']}>
    <div className={styles['circle-start']}>
      <HailIcon style={{ color: LIGHT_GRAY, fontSize: 20 }} />
    </div>
  </div>
);
interface RunningIconProps {
  iconColor?: string;
}

const RunningIcon: FC<RunningIconProps> = ({ iconColor = LIGHT_GRAY }) => (
  <div className={styles['running-container']}>
    <div className={styles['shiny']}>
      <div className={styles['circle']} style={{ width: 40, height: 40 }}>
        <div className={styles['circle-content']}>
          <DirectionsWalkIcon style={{ color: iconColor, fontSize: 20 }} />
        </div>
      </div>
    </div>
    {/*<div className={styles['arrow']} />*/}
  </div>
);

const StoppedIcon = () => (
  <div className={styles['stopped-container']}>
    <div
      className={styles['circle-stopped']}
      style={{
        position: 'relative',
        right: 2,
        top: -3,
      }}
    >
      <DirectionsWalkIcon style={{ color: WARNING, fontSize: 20 }} />
    </div>
    <div className={styles['close']}>
      <Icon icon="carbon:stop-sign" style={{ width: '100%', height: '100%' }} color={WARNING} />
    </div>
  </div>
);

export const TransportState: FC<TransportStateProps> = ({ state }) => {
  const renderState = () => {
    switch (state) {
      case 'start':
        return <StartIcon />;
      case 'running':
        return <RunningIcon />;
      case 'stopped':
        return <StoppedIcon />;
      default:
        return null;
    }
  };

  return <div className={styles['container']}>{renderState()}</div>;
};

export default TransportState;
